import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FertilizerBaseDialog } from '../../ranch-settings/modals/fertilizer/fertilizer.dialog.base';
import { IRanchFertilizerFormResult } from '../../ranch-settings/modals/fertilizer/interfaces';
import { RanchFertilizerFormComponent } from '../../ranch-settings/shared/ranch-fertilizer-form/main';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-fertilizer-dialog',
	templateUrl: 'fertilizer-dialog.html',
	styleUrls: ['fertilizer-dialog.scss']
})

export class RanchCreateFertilizerDialog extends FertilizerBaseDialog {
	public selectedFertilizerIds: number[];

	@ViewChild(RanchFertilizerFormComponent, { static: false })
	public fertilizerForm: RanchFertilizerFormComponent;

	constructor(
		protected _dialog: MatDialog,
		private _dialogRef: MatDialogRef<RanchCreateFertilizerDialog>,
		@Inject(MAT_DIALOG_DATA) private _dialogData: { selectedFertilizerIds: number[] }
	) {
		super(_dialog, null);
		this.selectedFertilizerIds = this._dialogData && this._dialogData.selectedFertilizerIds ?
			this._dialogData.selectedFertilizerIds : [];
	}

	public close(): void {
		if (!this.fertilizerForm || !this.fertilizerForm.isTouched) {
			this._dialogRef.close();
		} else {
			this._openKeepDiscardDialog();
		}
	}

	public submit(result: IRanchFertilizerFormResult): void {
		this._dialogRef.close(result.Fertilizers);
	}
}
